import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ThoughtsView from '../components/Views/ThoughtsView';
import { fetchThoughts } from '../store/actions/thoughtsActions';
import { fetchUserData } from '../store/actions/userActions';
import { ORG_THOUGHTS, SET_SEEN_NOTIFICATIONS } from '../store/actions/types';
import { deletePostAttachment } from '../store/actions/attachmentActions';

class Organisational extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: window.innerHeight,
      minData: 6,
      isFetchingMore: false,
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    const distanceFromBottom = docHeight - (scrollTop + viewportHeight);
    const preloadThreshold = 300; // px before bottom
    if (distanceFromBottom <= preloadThreshold && !this.state.isFetchingMore) {
      this.setState(prev => ({ minData: prev.minData + 6, isFetchingMore: true }), () => {
        this.fetchData();
        setTimeout(() => this.setState({ isFetchingMore: false }), 500);
      });
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);

    this.fetchData(); // Always fetch fresh data
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  fetchData = () => {
    const params = {
      type: ORG_THOUGHTS,
      companyID: this.props.userdata.companyID,
      orderChild: 'publish_status',
      equalTo: this.props.userdata.companyID + '_approved',
      minData: this.state.minData,
    };

    this.props.fetchThoughts(params);

    this.props.fetchUserData({
      type: SET_SEEN_NOTIFICATIONS,
      userID: this.props.userdata.userID,
      path: this.props.match.path,
      unseenotifications: this.props.unseenotifications.unseenotifications,
    });
  };

  // Callback for ThoughtsView to request more data (e.g., when filter is activated)
  increaseMinData = (newMinData) => {
    if (newMinData > this.state.minData) {
      this.setState({ minData: newMinData }, () => {
        this.fetchData()
      })
    }
  }

  render() {
    const { thoughts, userdata } = this.props;


    return (
      <div>
        {userdata && thoughts ? (
          <ThoughtsView
            thoughts={thoughts}
            currentUser={userdata}
            {...this.props}
            openFileViewer={this.props.openFileViewer}
            increaseMinData={this.increaseMinData}
          />
        ) : null}
      </div>
    );
  }
}

Organisational.propTypes = {
  fetchThoughts: PropTypes.func.isRequired,
  thoughts: PropTypes.array,
  userdata: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  thoughts: state.thoughts.organisational || [], // Default to empty array
  userdata: state.userDialog.userDetails[0],
  unseenotifications: state.userdata.unseenotifications,
});

const mapDispatchToProps = (dispatch) => ({
  fetchThoughts: (params) => dispatch(fetchThoughts(params)),
  deletePostAttachment: (params) => dispatch(deletePostAttachment(params)),
  fetchUserData: (params) => dispatch(fetchUserData(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Organisational);

// import React, { Component } from "react";
// import PropTypes from "prop-types";
// import { connect } from "react-redux";
// import ThoughtsView from "../components/Views/ThoughtsView";
// import { fetchThoughts } from "../store/actions/thoughtsActions";
// import { fetchUserData } from "../store/actions/userActions";
// import { ORG_THOUGHTS, SET_SEEN_NOTIFICATIONS } from "../store/actions/types";
// import { deletePostAttachment } from "./../store/actions/attachmentActions";

// class Organisational extends Component {
//   constructor (props) {
//     super(props);
//     this.state = {
//       height: window.innerHeight,
//       minData: 6
//     };
//     this.handleScroll = this.handleScroll.bind(this);
//   }
//   handleScroll() {
//     const windowHeight =
//       "innerHeight" in window
//         ? window.innerHeight
//         : document.documentElement.offsetHeight;
//     const body = document.body;
//     const html = document.documentElement;
//     const docHeight = Math.max(
//       body.scrollHeight,
//       body.offsetHeight,
//       html.clientHeight,
//       html.scrollHeight,
//       html.offsetHeight
//     );
//     const windowBottom = Math.round(windowHeight + window.pageYOffset);
//     if (windowBottom >= docHeight) {
//       this.setState({
//         minData: this.state.minData + 6
//       });
//       this.fetchData();
//     }
//   }

//   componentDidMount() {
//     window.addEventListener("scroll", this.handleScroll);
//     if (this.props.thoughts.length !== 0) {
//       // Thoughts already loaded
//     } else {
//       this.fetchData()
//     }
//   }

//   componentWillUnmount() {
//     window.removeEventListener("scroll", this.handleScroll);
//   }

//   componentWillMount = () => {
//    // this.fetchData();
//   };

//   fetchData = () => {
//     var params = {
//       type: ORG_THOUGHTS,
//       companyID: this.props.userdata.companyID,
//       orderChild: "publish_status",
//       equalTo: this.props.userdata.companyID + "_approved",
//       minData: this.state.minData
//       // userID: this.props.userdata.userID,
//       // companyName: this.props.userdata.companyName,
//       // firstName: this.props.userdata.firstName,
//       // lastName: this.props.userdata.lastName,
//       // points: this.props.userdata.points ? this.props.userdata.points : ''
//     };
//     this.props.fetchThoughts(params);

//     this.props.fetchUserData({
//       type: SET_SEEN_NOTIFICATIONS,
//       userID: this.props.userdata.userID,
//       path: this.props.match.path,
//       unseenotifications: this.props.unseenotifications.unseenotifications
//     });
//   };
//   render() {
//     const { thoughts, userdata } = this.props;
//     return (
//       <div>
//         {userdata && thoughts ? (
//           <React.Fragment>
//             <ThoughtsView
//               thoughts={this.props.thoughts}
//               thoughtsb={this.props.thoughts}
//               currentUser={userdata}
//               {...this.props}
//               openFileViewer={this.props.openFileViewer}
//             />
//           </React.Fragment>
//         ) : null}
//       </div>
//     );
//   }
// }

// Organisational.propTypes = {
//   fetchThoughts: PropTypes.func.isRequired,
//   thoughts: PropTypes.array,
//   userdata: PropTypes.object.isRequired
// };

// const mapStateToProps = state => {
//   return {
//     thoughts: state.thoughts.organisational,
//     userdata: state.userDialog.userDetails[0],
//     unseenotifications: state.userdata.unseenotifications
//   };
// };

// const mapDispatchToProps = dispatch => {
//   return {
//     fetchThoughts: params => dispatch(fetchThoughts(params)),
//     deletePostAttachment: params => dispatch(deletePostAttachment(params)),
//     fetchUserData: params => dispatch(fetchUserData(params))
//   };
// };

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(Organisational);
